import React from "react";
import AllRecallStore from "./AllRecallStore";
import CurrentRecalls from "./components/CurrentRecalls";
import VehicleLookup from "./components/VehicleLookup";
import { inject, observer } from "mobx-react";
import StepNav from "../StepNav";
import Loader from "../Loader";
import RecallVehicleDetails from "./components/RecallVehicleDetails";
import InternalServerError from "./components/InternalServerError";
import VehicleNotFound from "./components/VehicleNotFound";
import VehicleNotAffected from "./components/VehicleNotAffected";
import VehicleRecalls from "./components/VehicleRecalls";

interface AllRecallProps {}

interface InjectedProps extends AllRecallProps {
  allRecallStore: AllRecallStore;
}

interface AllRecallState {}

class alllRecallContent extends React.Component<AllRecallProps, AllRecallState> {
  constructor(props: AllRecallProps) {
    super(props);
  }

  get injected() {
    return this.props as InjectedProps;
  }

  componentDidMount(): void {
    const { allRecallStore } = this.injected;
    allRecallStore.getCurrentRecalls();
    allRecallStore.stepNav = new StepNav();

    window["pushDigitalData"]({
      "event": "_pageLoaded"
    });
    allRecallStore.stepNav.onChangeComplete = (step: number) => {
      window['pushDigitalData']({
        "event": "_formNavigate",
        "form": {
            "name": allRecallStore.stepNav.groupTitle,
            "stage": (allRecallStore.stepNav.scope.querySelector("li.is-active span")).textContent
        },
      }, true);
    };
  }

  findCar = (vin) => {
    const { allRecallStore } = this.injected;
    allRecallStore.findCarByVin(vin);
  };

  onShowRecalls = (e: any) => {
    const { allRecallStore } = this.injected;
    e.preventDefault();
    allRecallStore.stepNav.navigate();
  };

  render() {
    const { allRecallStore } = this.injected;
    const vehicleRecall = allRecallStore.vehicleRecall;
    return (
      <div>
        <div className="step-nav-wrapper" data-step-title="Vehicle recalls">
          <ul className="step-nav">
            <li className="is-active">
              <span className="step-nav-desktop">My Vehicle Details</span>
              <span className="step-nav-mobile"></span>
            </li>
            <li>
              <span className="step-nav-desktop">Confirm My Vehicle</span>
              <span className="step-nav-mobile"></span>
            </li>
            <li>
              <span className="step-nav-desktop">My Vehicle Recalls</span>
              <span className="step-nav-mobile"></span>
            </li>
          </ul>
        </div>
        <div className="container margin-top-20px">
          <div className="stepNavSection is-active all-recall-form">
            <VehicleLookup stepNav={allRecallStore.stepNav} findCar={this.findCar} />
            <Loader isLoading={allRecallStore.currentRecalls.length == 0} isPositionRelative={false} />
            <CurrentRecalls />
          </div>
          <div className="stepNavSection row">
            {!allRecallStore.vehicleRecall.isRequestError && allRecallStore.vehicleRecall.isRecallExist ? (
              <RecallVehicleDetails showRecalls={this.onShowRecalls} />
            ) : vehicleRecall.isRequestError && vehicleRecall.RequestErrorStatusCode == "404" ? (
              <VehicleNotAffected />
            ) : vehicleRecall.isRequestError && vehicleRecall.RequestErrorStatusCode == "500" ? (
              <InternalServerError />
            ) : (
              <VehicleNotFound />
            )}
          </div>

          <div className="stepNavSection row">
            <VehicleRecalls />
          </div>
        </div>
      </div>
    );
  }
}

export default inject("allRecallStore")(observer(alllRecallContent));
